import {
  deleteTenantVariableConfig,
  patchTenantVariableConfig,
  patchTenantVariableValue,
} from "./tenant-variables.api";
import {
  normalizeTenantVariableDraft,
  normalizeTenantVariableValueDraft,
} from "./tenant-variables.mappers";
import type {
  TenantVariableDraft,
  TenantVariableValueDraft,
  VariableRow,
} from "./types";

type TenantPatchResponse = {
  tenant_id: string;
};

export async function patchTenantVariablesAndValues(params: {
  tenantId: string;
  variables?: TenantVariableDraft[];
  variable_values?: TenantVariableValueDraft[];
}): Promise<TenantPatchResponse> {
  return patchTenantVariableConfig({
    tenantId: params.tenantId,
    variables: params.variables?.map(normalizeTenantVariableDraft),
    variable_values: params.variable_values,
  });
}

export async function upsertTenantVariables(params: {
  tenantId: string;
  variables: TenantVariableDraft[];
}): Promise<TenantPatchResponse> {
  return patchTenantVariablesAndValues({
    tenantId: params.tenantId,
    variables: params.variables,
  });
}

export async function deleteTenantVariable(params: {
  tenantId: string;
  variableId: string;
}): Promise<{ tenant_id: string; variable_id: string }> {
  return deleteTenantVariableConfig(params);
}

export async function upsertTenantVariableValue(params: {
  tenantId: string;
  value: TenantVariableValueDraft;
}): Promise<{ tenant_id: string; variable_id: string }> {
  return patchTenantVariableValue({
    tenantId: params.tenantId,
    value: params.value,
  });
}

export function toTenantVariableValueDraft(params: {
  variable: VariableRow;
  value: unknown;
}): TenantVariableValueDraft {
  return normalizeTenantVariableValueDraft(params);
}
